<template>
    <div class="amount-input-container">
      <div class="input-group">
        <label for="inputAmount">金额</label>
        <!-- 修改部分：根据 gameid 显示不同的输入方式 -->
        <template v-if="gameid === '2'  || gameid === '3'">
          <!-- 当 gameid 为 3 时，下拉列表添加 180 选项 -->
          <select 
            id="inputAmount" 
            v-model="inputAmount" 
            :disabled="isGameIdOne"
            @change="validateInputAmount"
          >
            <option value="5">5</option>
            <option value="80">80</option>
            <option value="90">90</option>
            <option value="100">100</option>
            <option value="120">120</option>
            <template v-if="gameid === '3'">
              <option value="180">180</option>
            </template>
          </select>
        </template>
        <template v-else>
          <input 
            type="number" 
            id="inputAmount" 
            v-model="inputAmount" 
            :disabled="isGameIdTwo || isGameIdOne"
            placeholder="输入金额，只能充值2000元以下金额"
            @input="validateInputAmount"
            min="1" 
            step="1"
          >
        </template>
      </div>
      <!-- 新增名称输入框 -->
      <div class="input-group">
        <label for="buyerName">购买者姓名</label>
        <input 
          type="text" 
          id="buyerName" 
          v-model="buyerName" 
          placeholder="请输入购买者姓名"
        >
        <!-- 新增说明信息 -->
        <div class="name-note">名称起查账口令作用，乱写容易导致充值错误，损失自行承担</div>
      </div>
      <!-- 新增错误提示 -->
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
      <!-- 修改按钮点击事件，添加 isSubmitting 判断 -->
      <button 
      @click="submitAmount" 
      class="submit-button"
      :disabled="isSubmitting"
    >
      {{ isSubmitting ? '提交中...' : '确定' }}
    </button>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import md5 from 'js-md5';
  
  export default {
    data() {
      return {
        inputAmount: '',
        isGameIdTwo: false,
        isGameIdOne: false,
        gameid: null,
        id: null,
        urlAmount: null,
        payChannelId: null,
        buyerName: '', 
        errorMessage: '',
        // 新增提交状态标志
        isSubmitting: false 
      };
    },
    async mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      this.gameid = urlParams.get('gameid');
      this.id = urlParams.get('id');
      this.urlAmount = urlParams.get('amount');
      this.payChannelId = urlParams.get('paychannelid');
  
      // 修改部分：将判断条件从 gameid === '2' 改为 gameid 等于 '2' 或 '3'
      if (this.gameid === '2' || this.gameid === '3') {
        this.isGameIdTwo = true;
        if (this.urlAmount && parseInt(this.urlAmount) > 0) {
          this.inputAmount = this.urlAmount;
          this.isGameIdOne = true; 
        } 
      } else if (this.gameid === '1' && this.urlAmount) {
        this.inputAmount = this.urlAmount;
        this.isGameIdOne = true;
      }
    },
    methods: {
      validateInputAmount() {
        // 修改部分：将判断条件从 !this.isGameIdTwo 改为 !this.isGameIdTwo 且 gameid 不等于 '2' 和 '3'
        if (!((this.gameid === '2' || this.gameid === '3') || this.isGameIdOne)) {
          let value = parseInt(this.inputAmount);
          if (isNaN(value) || value < 1) {
            this.inputAmount = '1';
          } else if (value > 2000) {
            this.inputAmount = '2000';
          }
        }
      },
      async submitAmount() {
        // 若正在提交，直接返回
        if (this.isSubmitting) return;
        
        // 设置为正在提交状态
        this.isSubmitting = true;
        // 清空之前的错误信息
        this.errorMessage = '';
        // 检查 buyerName 是否为空
        if (!this.buyerName.trim()) {
          // 修改为页面显示错误提示
          this.errorMessage = '购买者姓名不能为空';
          // 提交失败，重置提交状态
          this.isSubmitting = false;
          return;
        }
        try {
          const key = process.env.VUE_APP_API_KEY;
          const timestamp = new Date().getTime();
          const token = md5(timestamp + key);
          const response = await axios.post(`${window.location.origin}/api2/Pay3`, {
            amount: this.inputAmount,
            id: this.id,
            token: token,
            gameid: this.gameid,
            payChannelId: this.payChannelId,
            timestamp: timestamp,
            buyerName: this.buyerName, 
          });
          console.log('创建订单响应:', response.data);
          const payUrl = response.data.data.payurl;
          if (payUrl) {
            window.location.href = payUrl;
          } else {
            this.errorMessage = '未获取到有效的支付链接';
          }
        } catch (error) {
          this.errorMessage = '创建订单失败: ' + error.message;
        } finally {
          // 无论请求成功或失败，都重置提交状态
          this.isSubmitting = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .amount-input-container {
    text-align: center;
    padding: 20px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0px 3px 6px 0px #232B321A;
    margin: 20px auto;
    width: calc(100% - 40px);
  }
  .input-group {
    margin-bottom: 15px;
  }
  .input-group label {
    display: block;
    margin-bottom: 5px;
    color: #333;
    font-weight: 600;
    font-size: 1.2rem;
  }
  .input-group input,
  .input-group select { 
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.8rem;
  }
  .submit-button {
    background: #3F9FFF;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    font-size: 0.8rem;
  }
  .submit-button:hover {
    background: #2e86d9;
  }
  /* 新增错误提示样式 */
  .error-message {
    color: red;
    margin-bottom: 10px;
  }
  .name-note {
    font-size: 0.8rem;
    color: #ff6666;
    text-align: left;
    margin-top: 5px;
  }
  </style>